export const mapsDirectionsUrl = (lat, lng) =>
  `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}`;

export const hasDeliveryCoords = (order) =>
  Number.isFinite(order?.deliveryLat) && Number.isFinite(order?.deliveryLng);
